/*!
 * All material copyright ESRI, All Rights Reserved, unless otherwise specified.
 * See https://github.com/Esri/calcite-design-system/blob/dev/LICENSE.md for details.
 * v2.13.2
 */
export const autoMode = "calcite-mode-auto";
export const darkMode = "calcite-mode-dark";
const lightMode = "calcite-mode-light";
export const MODES = [
    {
        name: "light",
        className: lightMode,
    },
    {
        name: "dark",
        className: darkMode,
    },
    {
        name: "auto",
        className: autoMode,
    },
];
export const CSS_UTILITY = {
    autoMode,
    darkMode,
    lightMode,
    rtl: "calcite--rtl",
    calciteAnimate: "calcite-animate",
    calciteAnimateIn: "calcite-animate__in",
    calciteAnimateInUp: "calcite-animate__in-up",
    calciteAnimateInDown: "calcite-animate__in-down",
    calciteAnimateInRight: "calcite-animate__in-right",
    calciteAnimateInLeft: "calcite-animate__in-left",
    calciteAnimateInScale: "calcite-animate__in-scale",
};
export const TEXT = {
    loading: "Loading",
};
export const DEBOUNCE = {
    filter: 250,
    nextTick: 0,
    resize: 150,
    reposition: 100,
};
//# sourceMappingURL=resources.js.map
